// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2Cre0","file":"styles_file__2i-nL"};